/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */

export type SimulationItemMetadataDtoKind = typeof SimulationItemMetadataDtoKind[keyof typeof SimulationItemMetadataDtoKind];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SimulationItemMetadataDtoKind = {
  simulation: 'simulation',
} as const;
